import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import SMConst from 'lib/SMConst';

// どこからも呼ばれていない
class SMOChangeGuestView extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    $('body').addClass('js-split-view');
  }

  sizeToFit() {
    if (this.state.display == SMConst.Display.Visible) {
      let $mainTable = $(this.refs.mainTable);
      let $mainTableFooter = $(ReactDOM.findDOMNode(this.refs.mainTableFooter));
      $mainTableFooter.outerWidth($mainTable.outerWidth());
    }
  }

  formDidSubmit(e) {
    e.preventDefault();
    $(document).trigger("SMHideDialog");
  }

  linkDidClick(e) {
    e.preventDefault();
    if (e.currentTarget.name == 'close') {
      this.formDidSubmit(e);
    }
  }

  textFieldDidClick(e) {
    if (e.currentTarget.name == 'calendar_url') {
      e.currentTarget.select();
    }
  }

  render() {
    return(
      <div className="maincol-lightbox">
        <div className="form-casette maincol-lightbox__form">
          <form onSubmit={this.formDidSubmit.bind(this)}>
            <h2 className="dashboard-title mb20">{I18n.t('dashboard.text_000601')}
             <span className="dashboard-title__supplement mr15">{I18n.t('dashboard.text_000602')}</span></h2>
            <div className="form-box ta-c">
              <p className="mt20 mb30">
                <input
                  type="text"
                  name='invite_url'
                  className="form-text w500 mr10"
                  value={'https://' + location.host + '/invitations/' + this.props.reservation.uid}
                  readOnly={true}
                  onClick={this.textFieldDidClick.bind(this)}
                />
              </p>
              <input className="button-blue pt10 pb10 w200 mr5" type="button" value={I18n.t('dashboard.label_000602')} onClick={this.openEmail.bind(this)} />
              <input className="button-blue pt10 pb10 w200 ml5" type="button" value={I18n.t('dashboard.label_000603')} onClick={this.copy.bind(this)} />
            </div>
 
            <a href="#" name="close" className="form-casette__close" onClick={this.linkDidClick.bind(this)}><i className="fa fa-times"></i></a>
 
          </form>
        </div>
      </div>
    );
  }
}

SMOChangeGuestView.propTypes = {
  reservation: PropTypes.object.isRequired,
};
export default SMOChangeGuestView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMOChangeGuestView.jsx